import { render, staticRenderFns } from "./personalbill.vue?vue&type=template&id=5e44c1f7&scoped=true&"
import script from "./personalbill.vue?vue&type=script&lang=js&"
export * from "./personalbill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e44c1f7",
  null
  
)

export default component.exports